/* eslint-disable react-hooks/rules-of-hooks */

import { PredefinedGAEvents } from '../../types/PredefinedGAEvents';
import { usePageCategoryForEvent } from './usePageCategoryForEvent';

export type EventProps = {
  event_cta_position?: string;
  event_cta_section?: string;
  event_solution_name?: string;
  event_carousel_type?: string;
  event_form_name?: string;
  event_field_name?: string;
  event_error_type?: string;
  event_internal_campaign_name?: string;
  text?: string;
};

export type GetEventPayloadProps = {
  pathname: string;
  event: PredefinedGAEvents;
  eventProps?: EventProps;
  isCampaign?: boolean;
};

export const getEventPayload = ({
  pathname,
  event,
  eventProps,
  isCampaign,
}: GetEventPayloadProps) => {
  const basePayload = {
    source_page: pathname,
    page_category: usePageCategoryForEvent(pathname, isCampaign),
  };

  const eventPayload: Record<PredefinedGAEvents, object> = {
    K_download_company_presentation: basePayload,
    MK_click_preheader_link: basePayload,
    E_cta_to_form: {
      ...basePayload,
      cta_position: eventProps?.event_cta_position || '',
      cta_section: eventProps?.event_cta_section || '',
      cta_text: eventProps?.text || '',
    },
    E_cta_to_landing: basePayload,
    E_cta_to_main: basePayload,
    E_cta_to_case_study: basePayload,
    E_cta_to_blog: basePayload,
    E_cta_nav_menu: basePayload,
    E_cta_footer: basePayload,
    E_click_logo_home: basePayload,
    E_FAQ_expand: basePayload,
    E_solutions_expand: {
      ...basePayload,
      solution_name: eventProps?.event_solution_name || '',
      solution_text: eventProps?.text || '',
    },
    E_click_carousel: {
      ...basePayload,
      carousel_type: eventProps?.event_carousel_type || '',
    },
    E_click_blog_breadcrumb: basePayload,
    E_click_copy_article_link: basePayload,
    E_click_share_facebook: basePayload,
    E_click_share_x: basePayload,
    E_click_share_linkedin: basePayload,
    E_click_blog_internal_link_banner: basePayload,
    E_click_blog_internal_link_text: basePayload,
    E_cta_blog_banner_to_estimate: basePayload,
    E_cta_blog_nav_menu: basePayload,
    E_cta_blog_banner_landing: basePayload,
    E_cta_blog_banner_to_case_study: basePayload,
    K_form_sent: {
      ...basePayload,
      form_name: eventProps?.event_form_name,
      internal_campaign_name: eventProps?.event_internal_campaign_name,
    },
    MK_form_start: {
      ...basePayload,
      form_name: eventProps?.event_form_name,
    },
    MK_form_abandoned: {
      ...basePayload,
      form_name: eventProps?.event_form_name,
      field_name: eventProps?.event_field_name,
    },
    MK_form_error: {
      ...basePayload,
      form_name: eventProps?.event_form_name,
      error_type: eventProps?.event_error_type,
    },
  };

  return eventPayload[event];
};
